// KEEP IDENTICAL WITH moveTeamToPouleSpot IN CLOUD FUNCTIONS
export const moveTeamToPouleSpot = (
  batch,
  teamId,
  pouleId,
  numInPoule,
  oldTeam = null,
  status = null,
  isResultSpot = false,
  tournament,
  poulesByKey,
  bracketsByKey,
  resultSpotsAll,
  teams,
  fase
) => {
  const db = window.firebase.firestore();
  const tournamentRef = db.collection("tournaments").doc(tournament[".key"]);

  const teamsRef = tournamentRef.collection("teams");

  const resultSpotsRef = tournamentRef.collection("resultSpots");

  let poule = poulesByKey[pouleId];
  if (!poule) {
    return batch;
  }

  let opponentIsBye = false;
  let pouleKeyName = fase;
  let resultSpot = null;
  let resultSpotLoser = null;
  let toPouleId = null;
  let toPouleIdLoser = null;
  let toNumInPoule = null;
  let toNumInPouleLoser = null;
  let opponent = null;
  if (poule.bracket) {
    const bracket = bracketsByKey[poule.bracket] || {};
    opponentIsBye =
      numInPoule === 0
        ? poule["status1"] === "bye"
        : poule["status0"] === "bye";
    pouleKeyName =
      poule.bracketRound === bracket.size && !bracket.subBracketTo
        ? poule.fase
        : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
    resultSpot = resultSpotsAll.find(
      (rs) =>
        rs.fromPoule === pouleId &&
        rs.rank === 0 &&
        rs.belongsToBracket === poule.bracket
    );
    toPouleId = resultSpot["poule" + poule.fase];
    toNumInPoule = resultSpot["numInPoule" + poule.fase];

    resultSpotLoser = resultSpotsAll.find(
      (rs) =>
        rs.fromPoule === pouleId &&
        rs.rank === 1 &&
        rs.belongsToBracket === poule.bracket
    );
    toPouleIdLoser = resultSpotLoser["poule" + poule.fase];
    toNumInPouleLoser = resultSpotLoser["numInPoule" + poule.fase];

    opponent = teams.find(
      (t) =>
        t["poule" + pouleKeyName] === pouleId &&
        t["numInPoule" + pouleKeyName] === (numInPoule === 0 ? 1 : 0)
    );
  }

  // check for old team first (team or status (bye/noShow))
  if (oldTeam === null) {
    let emptySpot = { empty: true, status: poule["status" + numInPoule] };
    emptySpot["poule" + fase] = poule.id;
    emptySpot["numInPoule" + fase] = numInPoule;
    oldTeam =
      teams.find(
        (t) =>
          t["poule" + pouleKeyName] === pouleId &&
          t["numInPoule" + pouleKeyName] === numInPoule
      ) || emptySpot;
  }
  if (!oldTeam.empty) {
    // remove old team or resultSpot
    let oldTeamRef = teamsRef.doc(oldTeam.id);
    if (oldTeam.resultSpot) {
      oldTeamRef = resultSpotsRef.doc(oldTeam.id);
    }
    let update = {};
    update["poule" + pouleKeyName] = null;
    batch.update(oldTeamRef, update);
    if (opponentIsBye) {
      // remove from next round
      batch = moveTeamToPouleSpot(
        batch,
        null,
        toPouleId,
        toNumInPoule,
        null,
        null,
        false,
        tournament,
        poulesByKey,
        bracketsByKey,
        resultSpotsAll,
        teams,
        fase
      );
    }
  }

  if (oldTeam.status) {
    // remove old status (bye/noShow)
    let oldPouleRef = tournamentRef.collection("poules").doc(pouleId);
    let toUpdate = {};
    toUpdate["status" + oldTeam["numInPoule" + fase]] = null;
    batch.update(oldPouleRef, toUpdate);
    if (oldTeam.status === "bye") {
      if (opponent || opponentIsBye) {
        // check for opponent in next round and remove
        batch = moveTeamToPouleSpot(
          batch,
          null,
          toPouleId,
          toNumInPoule,
          null,
          null,
          false,
          tournament,
          poulesByKey,
          bracketsByKey,
          resultSpotsAll,
          teams,
          fase
        );
      }

      if (toPouleIdLoser && !opponentIsBye) {
        // remove bye from subbracket
        batch = moveTeamToPouleSpot(
          batch,
          null,
          toPouleIdLoser,
          toNumInPouleLoser,
          null,
          null,
          false,
          tournament,
          poulesByKey,
          bracketsByKey,
          resultSpotsAll,
          teams,
          fase
        );
      }
    }
  }

  if (teamId) {
    let newTeamRef = teamsRef.doc(teamId);
    if (isResultSpot) {
      newTeamRef = resultSpotsRef.doc(teamId);
    }
    let update = {};
    update["poule" + pouleKeyName] = pouleId;
    update["numInPoule" + pouleKeyName] = numInPoule;
    batch.update(newTeamRef, update);
    if (opponentIsBye) {
      // to next round
      batch = moveTeamToPouleSpot(
        batch,
        teamId,
        toPouleId,
        toNumInPoule,
        null,
        null,
        false,
        tournament,
        poulesByKey,
        bracketsByKey,
        resultSpotsAll,
        teams,
        fase
      );
    }
  } else if (status === "bye" || status === "noShow") {
    let pouleRef = tournamentRef.collection("poules").doc(pouleId);
    let toUpdate = {};
    toUpdate["status" + numInPoule] = status;
    batch.update(pouleRef, toUpdate);

    if (status === "bye") {
      if (toPouleIdLoser) {
        // set bye in subbracket
        batch = moveTeamToPouleSpot(
          batch,
          null,
          toPouleIdLoser,
          toNumInPouleLoser,
          null,
          "bye",
          false,
          tournament,
          poulesByKey,
          bracketsByKey,
          resultSpotsAll,
          teams,
          fase
        );
      }

      if (opponent) {
        // opponent to next round
        batch = moveTeamToPouleSpot(
          batch,
          opponent.id,
          toPouleId,
          toNumInPoule,
          null,
          null,
          false,
          tournament,
          poulesByKey,
          bracketsByKey,
          resultSpotsAll,
          teams,
          fase
        );
      } else if (opponentIsBye) {
        // bye to next round
        batch = moveTeamToPouleSpot(
          batch,
          null,
          toPouleId,
          toNumInPoule,
          null,
          "bye",
          false,
          tournament,
          poulesByKey,
          bracketsByKey,
          resultSpotsAll,
          teams,
          fase
        );
      }
    }
  }
  return batch;
};
